/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageRequest
 */
export interface PageRequest {
    /**
     * 
     * @type {number}
     * @memberof PageRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof PageRequest
     */
    limit?: number;
}

export function PageRequestFromJSON(json: any): PageRequest {
    return PageRequestFromJSONTyped(json, false);
}

export function PageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function PageRequestToJSON(value?: PageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offset': value.offset,
        'limit': value.limit,
    };
}


